import React from "react";

const SvgCalendar2 = props => (
  <svg viewBox="0 0 50 50" fill="#333" {...props}>
    <path d="M12 0c-1.094 0-2 .906-2 2v2H4c-1.16 0-2 .84-2 2v7h46V6c0-1.16-.84-2-2-2h-6V2c0-1.094-.906-2-2-2h-2c-1.094 0-2 .906-2 2v2H16V2c0-1.094-.906-2-2-2zm0 2h2v6h-2zm24 0h2v6h-2zM2 15v31c0 1.16.84 2 2 2h42c1.16 0 2-.84 2-2V15zm10 6h5v5h-5zm7 0h5v5h-5zm7 0h5v5h-5zm7 0h5v5h-5zm-21 7h5v5h-5zm7 0h5v5h-5zm7 0h5v5h-5zm7 0h5v5h-5zm-21 7h5v5h-5zm7 0h5v5h-5zm7 0h5v5h-5zm7 0h5v5h-5z" />
  </svg>
);

export default SvgCalendar2;
